import { Component, Input, OnInit } from '@angular/core';
import { EvaluationVehicle } from '@app-model/evaluation';
import { Vehicle } from '@app-model/vehicle';
import { SharedService } from '@app-services/shared.service';

@Component({
  selector: 'app-card-equipments',
  templateUrl: './card-equipments.component.html',
  styleUrls: ['./card-equipments.component.scss']
})
export class CardEquipmentsComponent implements OnInit {

  @Input() vehicle: EvaluationVehicle;
  @Input() castOffVehicle: Vehicle;
  equipments = [];

  get data(): Vehicle | EvaluationVehicle | undefined {
    return this.castOffVehicle || this.vehicle;
  }

  constructor(
    private readonly sharedService: SharedService
  ) { }

  ngOnInit(): void {

  if (this.castOffVehicle?.equipments?.length) {
    this.equipments = [...this.castOffVehicle.equipments].sort();
    return;
  }

  if (this.data.equipmentIds?.length) {
    this.sharedService.getEquipmentOptions().subscribe(allOptions => {
      const listEquips: string[] = [];
      for (const id of this.data.equipmentIds) {
        const found = allOptions.find(o => o.id === id);
        if (found) listEquips.push(found.name);
      }
      this.equipments = listEquips.sort();
    });
  }
}

}
